<template>
    <div data-component="strat.footer.v12020" class="strat-footer black">
        <v-container>
            <v-layout justify-space-between align-center>
                <v-flex shrink>
                    <v-layout align-center class="t24 white--text">
                        <span class="text-uppercase roboto font-weight-light">
                            Strategery
                        </span>
                        <span class="mx-3">
                            <v-card flat height="30" width="2" color="white"></v-card>
                        </span>
                        <span class="dolo font-weight-bold">
                            Better Tools. Better Results.
                        </span>
                    </v-layout>
                </v-flex>
                <v-flex shrink>
                    <v-layout row wrap justify-end class="white--text">
                        <v-flex shrink ml-3 v-for="(l, i) in navMenu" :key="i" class="footer-link">
                            <router-link :to="{name: l.to}" class="text-right t16 dolo"> {{l.title}}</router-link>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end>
                        <v-flex xs12 class="text-right grey--text text-darken-1">
                            <span class="text-right t14 roboto"> © {{cry}} DoloLabs LLC. All Rights Reserved.</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end>
                        <v-flex xs12 class="text-right grey--text text-darken-1">
                            <span class="text-right t14 roboto mr-4" @click="openTc()"> Terms of Service</span>
                            <span class="text-right t14 roboto" @click="openPp()"> Privacy Policy</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog width="50%" v-model="pp">
            <v-card class="pa-6">
                <privacy @closePp="closePp()"/>
            </v-card>
        </v-dialog>
        <v-dialog width="50%" v-model="tc">
            <v-card class="pa-6">
                <terms @closeTc="closeTc()"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
//import moment from 'moment'
import terms from '../views/terms'
import privacy from '../views/privacy-policy'

export default {
    name: 'stratFooter',
    components: {
        terms,
        privacy
    },
    props: {},
    data: () => {
        return {
            pp: false,
            tc: false,
            cry: 2020,
            navMenu : [
                {
                    title: 'Home',
                    subtitle: 'What we are',
                    color: 'tertiary',
                    to: 'home'
                },
                {
                    title: 'Investor Relations',
                    subtitle: 'Who we are',
                    color: 'tertiary',
                    to: 'investor_relations'
                },
            ]
        }
    },
     methods: {
        openPp(){
            this.pp = true
        },
        openTc(){
            this.tc = true
        },
        closePp(){
            this.pp = false
        },
        closeTc(){
            this.tc = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .strat-footer {
        position: relative;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 80px 0;

        a {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #2BCDC9 !important;
                text-decoration: none !important;
            }
        }
    }
</style>